import { Box, LinearProgress } from '@mui/material';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AUTH } from 'src/constants/localStorageKeys';
import { useAuth } from 'src/hooks/useAuth';
import Landing from 'src/pages/landing';
import ProtectedLayout from '../layout/ProtectedLayout';
import paths from './paths';

const PrivateRoute = () => {
  const auth = useAuth();
  const location = useLocation();
  const hasAuthToken = localStorage.getItem(AUTH);
  if (!auth) {
    throw new Error('useAuthActions must be used within an AuthProvider');
  }

  if (!hasAuthToken) {
    return location.pathname === paths.main ? (
      <Landing />
    ) : (
      <Navigate to={paths.signIn} replace />
    );
  }

  const { user } = auth;

  if (!user) {
    return (
      <Box
        sx={{
          display: 'flex',
          minHeight: '100vh',
          bgcolor: 'background.paper',
        }}
      >
        <LinearProgress color="secondary" sx={{ width: '100%' }} />
      </Box>
    );
  }

  switch (location.pathname) {
    case paths.onboarding:
    case paths.sandbox:
      return <Outlet />;
    default:
      return (
        <ProtectedLayout>
          <Outlet />
        </ProtectedLayout>
      )
  }
};

export default PrivateRoute;
